import {
  matchesSearch,
  LookupField,
  createLookupModel,
} from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import { Row, Col } from 'src/componentes/grid';

import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { STATUS_ITEM } from 'src/utils/constants';

import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import ProcessoLookup from 'src/lookups/processo';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import StatusRiscoLookup from 'src/lookups/status-item';
import MatrizRiscoLookup from 'src/lookups/matriz-risco';

const BasicsSection = ({
  model,
  resources,
  intl,
  searchQuery,
  fields: schemaFields,
}) => {
  const hasField = (fieldName) => Boolean(schemaFields?.[fieldName]);

  const fields = [
    hasField('nome') && {
      label: intl.formatMessage({ id: 'nome' }),
      id: 'nome',
    },

    hasField('idIntegracao') && {
      label: intl.formatMessage({ id: 'idIntegracao' }),
      id: 'idIntegracao',
    },

    hasField('areas') && {
      label: resources.areas,
      id: 'areas',
    },

    hasField('areasSubordinadas') && {
      label: intl.formatMessage(
        { id: 'label.considerarAreasSubordinadas' },
        { areas: resources.areas || 'Áreas' }
      ),
      id: 'areasSubordinadas',
    },

    hasField('processos') && {
      label: intl.formatMessage(
        { id: 'label.processos' },
        { processos: resources.processos }
      ),
      id: 'processos',
    },

    hasField('incluirSubprocessos') && {
      label: intl.formatMessage(
        { id: 'incluirSubprocessos' },
        {
          processosfilhosplural:
            resources.processosfilhosplural?.toLowerCase() || 'subprocessos',
        }
      ),
      id: 'incluirSubprocessos',
    },

    hasField('responsaveis') && {
      label: resources.responsaveis,
      id: 'responsaveis',
    },

    hasField('statusRisco') && {
      label: intl.formatMessage(
        { id: 'labelStatusRisco' },
        { risco: resources.risco }
      ),
      id: 'statusRisco',
    },

    hasField('filtroMatrizRisco') && {
      label: intl.formatMessage(
        { id: 'matrizRisco' },
        { risco: resources.risco }
      ),
      id: 'filtroMatrizRisco',
    },
  ].filter(Boolean);

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;

  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) {
    return null;
  }

  return (
    <CollapsibleSection
      title={intl.formatMessage({ id: 'label.informacoesBasicas' })}
      startOpen={true}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {visibleFields.includes(fields.find((f) => f.id === 'nome')) &&
          model?.getModel('nome') && (
            <Col md={12}>
              <Input model={model.getModel('nome')} />
            </Col>
          )}

        {visibleFields.includes(fields.find((f) => f.id === 'idIntegracao')) &&
          model?.getModel('idIntegracao') && (
            <Col md={12}>
              <Input model={model.getModel('idIntegracao')} />
            </Col>
          )}

        {visibleFields.includes(fields.find((f) => f.id === 'areas')) && (
          <Col md={12}>
            <LookupField
              Component={ItemOrganizacaoLookup}
              multi
              highlight={matchesSearch(resources?.areas, searchQuery)}
              model={createLookupModel(
                resources?.areas,
                model.getModel('areas')?.value,
                model.getModel('areas')?.requestChange
              )}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'areasSubordinadas')
        ) && (
          <Col md={12}>
            <Checkbox
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: resources?.areas || 'Áreas' }
                ),
                model.getModel('areasSubordinadas')?.value,
                model.getModel('areasSubordinadas')?.requestChange
              )}
              style={{ marginBottom: 10 }}
            />
          </Col>
        )}

        {visibleFields.includes(fields.find((f) => f.id === 'processos')) && (
          <Col md={12}>
            <LookupField
              Component={ProcessoLookup}
              multi
              highlight={matchesSearch(
                intl.formatMessage(
                  { id: 'label.processos' },
                  { processos: resources?.processos || 'Processos' }
                ),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'label.processos' },
                  { processos: resources?.processos || 'Processos' }
                ),
                model.getModel('processos')?.value,
                model.getModel('processos')?.requestChange
              )}
              data={{ TipoId: 5 }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'incluirSubprocessos')
        ) && (
          <Col md={12}>
            <Checkbox
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'incluirSubprocessos' },
                  {
                    processosfilhosplural:
                      resources?.processosfilhosplural?.toLowerCase() ||
                      'subprocessos',
                  }
                ),
                model.getModel('incluirSubprocessos')?.value,
                model.getModel('incluirSubprocessos')?.requestChange
              )}
              style={{ marginBottom: 10 }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'responsaveis')
        ) && (
          <Col md={12}>
            <LookupField
              Component={ColaboradorEGrupoSimplificadoLookup}
              abrirEmDrawer={true}
              compactMulti={true}
              multi
              highlight={matchesSearch(resources?.responsaveis, searchQuery)}
              model={createLookupModel(
                resources?.responsaveis,
                model.getModel('responsaveis')?.value,
                model.getModel('responsaveis')?.requestChange
              )}
            />
          </Col>
        )}

        {visibleFields.includes(fields.find((f) => f.id === 'statusRisco')) && (
          <Col md={12}>
            <LookupField
              Component={StatusRiscoLookup}
              multi
              highlight={matchesSearch(
                intl.formatMessage(
                  { id: 'labelStatusRisco' },
                  { risco: resources?.risco || 'Risco' }
                ),
                searchQuery
              )}
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'labelStatusRisco' },
                  { risco: resources?.risco || 'Risco' }
                ),
                model.getModel('statusRisco')?.value,
                model.getModel('statusRisco')?.requestChange
              )}
              data={{
                idsSelecionados: [
                  STATUS_ITEM.EM_PLANEJAMENTO,
                  STATUS_ITEM.ATIVO,
                  STATUS_ITEM.CONCLUIDO,
                  STATUS_ITEM.SUSPENSO,
                  STATUS_ITEM.CANCELADO,
                  STATUS_ITEM.REPROVADO,
                  STATUS_ITEM.REPROVADO_AGUARDANDO_SUBMISSAO,
                ],
              }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'filtroMatrizRisco')
        ) && (
          <Col md={12}>
            <LookupField
              Component={MatrizRiscoLookup}
              clearable
              highlight={matchesSearch('matriz', searchQuery)}
              model={createLookupModel(
                intl.formatMessage(
                  { id: 'matrizRisco' },
                  { risco: resources?.risco || 'Risco' }
                ),
                model.getModel('filtroMatrizRisco')?.value,
                model.getModel('filtroMatrizRisco')?.requestChange
              )}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};

export default BasicsSection;
